import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Md5 } from 'ts-md5/dist/md5';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-create-prueba',
  templateUrl: './create-prueba.component.html',
  styleUrls: ['./create-prueba.component.scss']
})
export class CreatePruebaComponent implements OnInit {
  displayedColumns
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreatePruebaComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }
  operacion = 'createdistribuidor';
  primerIntento = false;
  clientes = [];
  idenvio = 0;
  file; valor; script; file2; valor2;

  ngOnInit() {
    this.idenvio = this.data.cantidad + 1;
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editdistribuidor';
      // this.iddistribuidor = this.data.distribuidor.iddistribuidor;
      // this.grupoVal.controls.NOMBRE.setValue(this.data.distribuidor.nombre);
      // this.grupoVal.controls.TIPO.setValue(this.data.distribuidor.tipo);
    }
  }

  openInput() {
    document.getElementById("fileInput").click();
  }

  ObtenerArchivoCarga(event) {

    this.file = event.target.files[0];
    this.valor = this.file.name;
    if (typeof (this.file != "undefined")) {
      this.cargarLista();
    }
  }

  cargarLista() {
    this.spinner.show();
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('fileInput')).value = null;

      this.loadlistxls(dataexcel);
      // this.dialogRef.close({dataexcel:dataexcel,pais:this.PAIS,type:1});
    };
    reader.readAsBinaryString(this.file);

  }

  async loadlistxls(data) {
    this.primerIntento = true;
    this.clientes = this.convertirArreglo(data);
    // console.log('%%%%%% clientes &&&&&&&');
    // console.log(this.clientes)
  }

  convertirArreglo(data) {
    let keys = data.splice(0, 1)[0];
    // console.log(keys);
    let ret = [];
    try {
      data.forEach(element => {
        const obj: any = {};
        for (let index = 0; index < element.length; index++) {
          let aux: string = keys[index];
          aux = aux.replace('"', '').trim();
          obj[aux] = element[index];
        }
        if (obj.TELEFONO || obj.telefono) {
          ret.push(obj);
        }
      });
      this.spinner.hide();
      return ret;
    } catch (e) {
      this.spinner.hide();
      this.snackbar.open('Archivo no válido intente de nuevo.', 'Cerrar', { duration: 3000, });
      return ret;
    }
  }

  

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    this.spinner.show();
    let form = {
      IDENVIO: this.idenvio,
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      TIPO: this.grupoVal.controls.TIPO.value,
      CLIENTES: this.clientes
    }

    this.gateway.save('upsertEnvioMasivo', form).then((result) => {
      this.spinner.hide();
      if (result['resp']) {
        this.dialogRef.close(true);
        this.snackbar.open(result['msg'], 'Cerrar', {
          duration: 3000
        });
      } else {
        this.snackbar.open('Hubo un error al guardar los datos.', 'Cerrar', {
          duration: 3000
        });
      }
    }
    ).catch(function (e) {
      this.spinner.hide();
      this.snackbar.open('Hubo un error al guardar los datos.', 'Cerrar', {
        duration: 3000
      });
    });
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    TIPO: new FormControl(''
      // , [Validators.compose([
      //   Validators.required
      // ])]
    )
  });

  tipos = [
    { ID: 1, NOMBRE: 'Whatsapp', TIPO: 'WS' },
    { ID: 2, NOMBRE: 'SMS', TIPO: 'SMS' }
  ];

}
